import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // note default import

import { BaseButtons } from "../../../../../../components/atoms";

const PdfReportButton = ({ reportData, netSales, cash, card }) => {
  const generatePDF = () => {
    if (!reportData) return;

    const doc = new jsPDF("p", "pt", "a4");
    const margin = 40;
    let y = margin;

    // Header
    doc.setFontSize(18);
    doc.text("Consolidated Sales Report", 40, y);
    y += 30;

    doc.setFontSize(12);
    doc.text(
      `Period: ${reportData.period.startDate} to ${reportData.period.endDate}`,
      40,
      y
    );
    y += 16;
    doc.text(`Selected Date: ${reportData.period.selectedDate}`, 40, y);
    y += 16;
    doc.text(`Period Days:  ${reportData.period.periodDays}`, 40, y);
    y += 30;

    // Totals
    const { totals } = reportData;
    doc.setFontSize(14);
    doc.text("Totals", 40, y);
    y += 20;
    doc.setFontSize(12);
    doc.text(`Sales Value: R ${totals.registerCashUp.total}`, 40, y);
    y += 16;
    // doc.text(
    //   `Receipts Calculation - Cash: ${totals.receiptsCalculation.cash}, Card: ${totals.receiptsCalculation.card}`,
    //   40,
    //   y
    // );
    y += 16;
    doc.text(
      `Register Calculation - Cash: R ${totals.registerCashUp.cash}, Card: R ${totals.registerCashUp.card}`,
      40,
      y
    );
    y += 16;
    doc.text(`Total Tips: R ${totals.tipsTotal}`, 40, y);
    y += 20;

    // Products table
    const products = reportData.productsSold.map((p, i) => [
      i + 1,
      p.product.productName,
      p.qtySold,
      p.retailValue,
    ]);

    autoTable(doc, {
      startY: y,
      head: [["#", "Product Name", "Qty Sold", "(R) Retail Value"]],
      body: products,
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255 },
      margin: { left: margin, right: margin },
      theme: "grid",
    });

    // Save PDF
    doc.save(`Sales_Report_${reportData.period.endDate}.pdf`);
  };

  return (
    <BaseButtons
      label={"GENERATE PDF"}
      onClick={generatePDF}
      mini={true}
      marginTopFalse={true}
      size={160}
      marginRight={10}
      height={55}
    />
  );
};

export default PdfReportButton;
